import React, { 
	useRef, 
	useEffect,
	useState 
} from "react";
import { connect } from "react-redux";
import { 
	//CalciteNotice, 
	CalciteSwitch, CalciteLabel, CalciteButton ,
CalciteSelect,
CalciteOption,
CalciteIcon
} from "@esri/calcite-components-react";

import GeoJSONLayer from "@arcgis/core/layers/GeoJSONLayer";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import GroupLayer from '@arcgis/core/layers/GroupLayer';

import Legend from "@arcgis/core/widgets/Legend";
import { loadLayer, removeLayer } from "../../../../Flux/thunks";

import keys from "../../Layers/RSSBP/shellfish/keys";

const initialRenderer = {
	type: "class-breaks",
	field:'all_sample_size',
	
	legendOptions: {
		title: "Data Availability"
	},
	
	defaultLabel: 'Data Not Available for Selection',
	defaultSymbol: {
	  type: "simple-marker",
	  style: "x",
	  color: [127, 127, 127],
	  outline: {
		color: [0, 0, 0, 1],
		width: 1
	  },
	  size: "8px"
	},
	classBreakInfos: [
		{
		  minValue: 1,
		  maxValue: 999999,
		  symbol: {
			type: "simple-marker",
			style: "circle",
			color: [127, 127, 127, 0],
			outline: {
				color: [0, 0, 0, 1],
				width: 1
			},
			size: "8px"
		  },
		  label: "Data Available for selection"
		},
	]
	
	/*
	type: 'simple',
	label: 'Data Available for selection',
	symbol: {
	  type: "simple-marker",
	  style: "circle",
	  color: [127, 127, 127, 0],
	  outline: {
		color: [0, 0, 0, 1],
		width: 1
	  },
	  size: "8px"
	},
	*/
};
const prevalenceRenderer = {
	type: "class-breaks",
	field:'prev',
	legendOptions: {
		title: "All Data Available - Prevalence"
	},
	defaultLabel: 'Areas with No Data for Selected Timeframe',
	defaultSymbol: {
	  type: "simple-marker",
	  style: "x",
	  color: [127, 127, 127],
	  outline: {
		color: [0, 0, 0, 1],
		width: 1
	  },
	  size: "8px"
	},
	classBreakInfos: [
		{
		  minValue: 0,
		  maxValue: 0.5,
		  symbol: {
			type: "simple-marker", // autocasts as new SimpleFillSymbol()
			color: [60, 204, 180, 1], // "purple",
			outline: {
			  width: 2,
			  color: [127, 127, 127, 0.5]
			},
			size: "8px"
		  },
		  label: "Areas with Lower Prevalence"
		},
		{
		  minValue: .5,
		  maxValue: 1,
		  symbol: {
			type: "simple-marker", // autocasts as new SimpleFillSymbol()
			style:'square',
			color: [217, 43, 48, 1], //"blue",
			outline: {
			  width: 2,
			  color: [127, 127, 127, 0.5]
			},
			size: "8px"
		  },
		  label: "Areas with Higher Prevalence"
		},
		/*
		{
		  minValue: 2,
		  maxValue: 9999,
		  symbol: {
			type: "simple-marker",
			style: "x",
			color: [127, 127, 127],
			outline: {
			  color: [0, 0, 0, 1],
			  width: 1
			},
			size: "8px"
		  },
		  label: "No Available Data For the Selected Timeframe"
		},
		*/
		{
		  minValue: 9999,
		  maxValue: 9999,
		  symbol: {
			type: "simple-marker",
			style: "circle",
			color: [255, 223, 60, 1],
			outline: {
			  color: [0, 0, 0, 1],
			  width: 1
			},
			size: "10px"
		  },
		  label: "Location Selected for Comparison"
		},
		
	]
};

const highlightLayer = new GraphicsLayer({
	id: 'grower-tool-graphics-layer'
});
const specialGrowerLayer = new GeoJSONLayer({
	title: '',
	outFields: ['*'],
	url: `${process.env.REACT_APP_API_URL}/layers/growers`,
	renderer: initialRenderer,
	popupEnabled:true,
	popupTemplate:{
		title: `{state}: {region} - {subregion}`,
	
		actions: [{
			id:'comparison-point',
			title:'Comparison',
			content: 'Compare Data',
			className:'esri-icon-experimental'
		}],
		content: [
			{
				type: "fields",
				fieldInfos: [
					{
						fieldName: "latitude",
						label: "Latitude"
					},{
						fieldName: "longitude",
						label: "Longitude"
					},
				]
			},

			{
				type: "fields",
				title:'All Available Data',
				fieldInfos: [
					{
						fieldName: "all_sample_size",
						label: "Sample Size"
					},
					{
						fieldName: "all_prev",
						label: "Prevalence",
						
						format: {
							places: 2,
						}
					},{
						fieldName: "all_adv_prev",
						label: "Adv. Prevalence",
						format: {
							places: 2,
						}
					},{
						fieldName: "all_w_prev",
						label: "Weighted Prevalence",
						format: {
							places: 2,
						}
					},
				]
			},

			{
				type: "fields",
				title:'Past Three Years',
				fieldInfos: [
					{
						fieldName: "past_three_sample_size",
						label: "Sample Size"
					},
					{
						fieldName: "past_three_prev",
						label: "Prevalence",
						
						format: {
							places: 2,
						}
					},{
						fieldName: "past_three_adv_prev",
						label: "Adv. Prevalence",
						format: {
							places: 2,
						}
					},{
						fieldName: "past_three_w_prev",
						label: "Weighted Prevalence",
						format: {
							places: 2,
						}
					},
				]
			},

			{
				type: "fields",
				title:'Past Five Years',
				fieldInfos: [
					{
						fieldName: "past_five_sample_size",
						label: "Sample Size"
					},
					{
						fieldName: "past_five_prev",
						label: "Prevalence",
						
						format: {
							places: 2,
						}
					},{
						fieldName: "past_five_adv_prev",
						label: "Adv. Prevalence",
						format: {
							places: 2,
						}
					},{
						fieldName: "past_five_w_prev",
						label: "Weighted Prevalence",
						format: {
							places: 2,
						}
					},
				]
			}
		]
	},
	customParameters:{
		species: null,
		pathogen: null,
		years: 'all'
	}

});


const growerGroupLayer = new GroupLayer({
	title: 'Grower Tool Available Data Points',
	layers: [
		specialGrowerLayer,
		highlightLayer
	]
});
const DataForGrowersPanel = ({isMapLoading, loadLayerOnMap,removeLayerFromMap,arcgisMap, panelIsOpen}) => {

	const legendRef = useRef(null);

	const [lockMap, setLayerLock] = useState(process.env.NODE_ENV === 'development');
	const [showSettings, setShowSettings] = useState(false);
	//const [viewEvent, setViewEvent] = useState(false);
	const [dataOptions, SetDataOptions] = useState({
		speciesKey: null,
		pathogenKey: null,
		dataTimeframe: 'all'
	});
	const [selectedPoint, SetSelectedPoint] = useState(null);
	


	const UpdatePathogenOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			pathogenKey: _e.target.selectedOption.value,
		});
		SetSelectedPoint(null);
	}
	const UpdateSpeciesOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			speciesKey: _e.target.selectedOption.value,
		});
		SetSelectedPoint(null);
	}
	const UpdateDataTimeframe = (_e) => {
		SetDataOptions({
			...dataOptions,
			dataTimeframe: _e.target.selectedOption.value,
		});


	}

	const _PrevalenceListItem = () => {
		return(
			<>
				<li><strong>All Data Prevalence</strong>: {selectedPoint.attributes.all_prev && selectedPoint.attributes.all_prev!==-1? selectedPoint.attributes.all_prev.toFixed(2) : 'N/A'}</li>
				<li><strong>Past Three Years Prevalence</strong>: {selectedPoint.attributes.past_three_prev && selectedPoint.attributes.past_three_prev!==-1 ? selectedPoint.attributes.past_three_prev.toFixed(2) : 'N/A'}</li>
				<li><strong>Past Five Years Prevalence</strong>: {selectedPoint.attributes.past_five_prev && selectedPoint.attributes.past_five_prev!==-1? selectedPoint.attributes.past_five_prev.toFixed(2) : 'N/A'}</li>
			</>
		);
	}
	const ShowCurrentlySelectedPoint = () => {
		highlightLayer.graphics.removeAll();
		if( !selectedPoint ) {
			return (<h4><em>No comparison point selected.</em></h4>);
		}
		
		const myHighlight = selectedPoint.clone();
		myHighlight.symbol = {
			type: "simple-marker",
			style: "circle",
			color: [255, 255, 0, 1],
			outline: {
			  color: [0, 0, 0, 1],
			  width: 1
			},
			size: "10px"
		};
		highlightLayer.graphics.add(myHighlight);




		return (
			<>
				<h4>Selected Point</h4>	
				<div>
					<CalciteButton iconStart="trash" onClick={(_e) => {
					SetSelectedPoint(null);
				}}>Clear Selected Point</CalciteButton>
				</div>
				<div>
					<ul>
						<li><strong>State</strong>: {selectedPoint.attributes.state || 'N/A'}</li>
						<li><strong>Latitude</strong>: {selectedPoint.attributes.latitude || 'N/A'}</li>
						<li><strong>Longitude</strong>: {selectedPoint.attributes.longitude || 'N/A'}</li>
						<li><strong>Region</strong>: {selectedPoint.attributes.region || 'N/A'}</li>
						<li><strong>Subregion</strong>: {selectedPoint.attributes.subregion || 'N/A'}</li>
						<li><strong>Site Code</strong>: {selectedPoint.attributes.sitecode || 'N/A'}</li>
						{_PrevalenceListItem()}
					</ul>
				</div>
			</>
		);
	}


	useEffect(() => {
		//console.log(arcgisMap, isMapLoading);
	  	if (legendRef.current && !legendRef.current.children.length &&  arcgisMap.map) {

			arcgisMap.when( () => {
				new Legend({
					view: arcgisMap,
					container: legendRef.current,
					layerInfos:[{layer:specialGrowerLayer}],
					respectLayerVisibility: false
				});
			});

		}
	}, [arcgisMap]);
	

	useEffect(() => {
		specialGrowerLayer.on('refresh', () => {
			console.log('Special grower is refreshed.', 
			specialGrowerLayer);
		});

				
		specialGrowerLayer.on('layerview-create', ({view, layerView}) => {
			view.popup.on("trigger-action", (event) => {
				// Execute the measureThis() function if the measure-this action is clicked
				if (event.action.id === "comparison-point") {
					SetSelectedPoint(view.popup.selectedFeature);
				}
		  	});
			return;
		});

	}, [dataOptions, SetSelectedPoint]);

	useEffect( () => {
		console.log('Selected point has changed: ', selectedPoint);

		if( !selectedPoint || !selectedPoint.attributes ) {
			if(  dataOptions.dataTimeframe === 'all' ) {
				initialRenderer.field='all_sample_size';
				
			}else if(  dataOptions.dataTimeframe === 'past-three' ) {
				initialRenderer.field='past_three_sample_size';
				
			}else if(  dataOptions.dataTimeframe === 'past-five' ) {
				initialRenderer.field='past_five_sample_size';
				
			}

			specialGrowerLayer.renderer = initialRenderer;
			prevalenceRenderer.classBreakInfos[0].maxValue = .5;
			prevalenceRenderer.classBreakInfos[1].minValue = .5;

		}else{


			if(  dataOptions.dataTimeframe === 'all' ) {
				prevalenceRenderer.field='all_prev';
				prevalenceRenderer.legendOptions.title ='All Data Available - Prevalence';

				//if number of samples for prev is zero, we're returning since there's no point in switching the point...
				if( selectedPoint.attributes.all_sample_size < 1 ) {
					specialGrowerLayer.renderer = initialRenderer;
					prevalenceRenderer.classBreakInfos[0].maxValue = .5;
					prevalenceRenderer.classBreakInfos[1].minValue = .5;
					return;
				}else{
					prevalenceRenderer.classBreakInfos[0].maxValue = selectedPoint.attributes.all_prev;
					prevalenceRenderer.classBreakInfos[1].minValue = selectedPoint.attributes.all_prev;
				}

			}else if(  dataOptions.dataTimeframe === 'past-three' ) {
				prevalenceRenderer.field='past_three_prev';
				prevalenceRenderer.legendOptions.title ='Past Three Years - Prevalence';

				if( selectedPoint.attributes.past_three_sample_size < 1 ) {
					specialGrowerLayer.renderer = initialRenderer;
					prevalenceRenderer.classBreakInfos[0].maxValue = .5;
					prevalenceRenderer.classBreakInfos[1].minValue = .5;
					return;
				}else{
					prevalenceRenderer.classBreakInfos[0].maxValue = selectedPoint.attributes.past_three_prev;
					prevalenceRenderer.classBreakInfos[1].minValue = selectedPoint.attributes.past_three_prev;
				}
			}else if(  dataOptions.dataTimeframe === 'past-five' ) {

				prevalenceRenderer.field='past_five_prev';
				prevalenceRenderer.legendOptions.title ='Past Five Years - Prevalence';
				
				if( selectedPoint.attributes.past_five_sample_size < 1 ) {
					specialGrowerLayer.renderer = initialRenderer;
					prevalenceRenderer.classBreakInfos[0].maxValue = .5;
					prevalenceRenderer.classBreakInfos[1].minValue = .5;
					return;
				}else{
					prevalenceRenderer.classBreakInfos[0].maxValue = selectedPoint.attributes.past_five_prev;
					prevalenceRenderer.classBreakInfos[1].minValue = selectedPoint.attributes.past_five_prev;
				}
				
			}

			console.log('Using prevalence renderer :', prevalenceRenderer);

			specialGrowerLayer.renderer=prevalenceRenderer;
		}




	},[selectedPoint, dataOptions.dataTimeframe]);
	
	useEffect(() => {
		console.log('[DataForGrowersPanel]', panelIsOpen);
		if( panelIsOpen ) {
			loadLayerOnMap(growerGroupLayer);
			//loadLayerOnMap( specialGrowerLayer ) ;
			//loadLayerOnMap( highlightLayer );
		}else if( panelIsOpen === false && lockMap===false ) {
			removeLayerFromMap(growerGroupLayer);
			//removeLayerFromMap( specialGrowerLayer ) ;
			//removeLayerFromMap( highlightLayer );
		}
		
	}, [lockMap, panelIsOpen, loadLayerOnMap,removeLayerFromMap]);

	
	useEffect(() => {

		console.log(dataOptions, specialGrowerLayer);

		specialGrowerLayer.customParameters.species = (dataOptions.speciesKey ? keys.species[dataOptions.speciesKey].name : null);
		specialGrowerLayer.customParameters.pathogen = (dataOptions.pathogenKey ? keys.pathogens[dataOptions.pathogenKey].name : null);
		specialGrowerLayer.customParameters.years = (dataOptions.dataTimeframe);

		specialGrowerLayer.refresh();

	}, [dataOptions, SetSelectedPoint]);


/*

			<CalciteNotice active={true} color="yellow" style={{marginBottom:'1em'}}>
				<div slot="title">Grower Prevalence Tool</div>
				<div slot="message">This feature is still under development and is coming soon!</div>
			</CalciteNotice>
*/
	return (
		<div className="content-area">
			
			<div>
				<CalciteButton width="full" color="inverse" iconStart="gear" onClick={(_e) => {
					setShowSettings( !showSettings );
				}}>{ !showSettings ? 'Open Settings' : 'Close Settings'}</CalciteButton>
				<div style={{marginTop:'1rem',display: (showSettings ? 'block' : 'none')}}>
					<div>
						<div>
							<CalciteButton width="full" iconStart="addLayer" onClick={(_e) => {
								loadLayerOnMap(growerGroupLayer);
								//loadLayerOnMap( specialGrowerLayer );
								//loadLayerOnMap( highlightLayer );
							}}>Re-add Grower Layer</CalciteButton>
							<CalciteButton width="full" iconStart="refresh" color="neutral"onClick={(_e) => {
								specialGrowerLayer.refresh();
							}}>Manually Refresh Layer</CalciteButton>
							<CalciteButton width="full" iconStart="trash" color="red" onClick={(_e) => {
								removeLayerFromMap(growerGroupLayer);
								//removeLayerFromMap( specialGrowerLayer )
								//removeLayerFromMap( highlightLayer );
							}}>Remove Grower Layer</CalciteButton>
						</div>
						<div>
							<CalciteLabel>Keep layer on map when closed?
							<CalciteSwitch 
							checked={lockMap || undefined}
							onCalciteSwitchChange={(e) => { 
								if( e.detail.switched ) {
									setLayerLock(true);
								}else{
									setLayerLock(false);
								}
							}}></CalciteSwitch>
							</CalciteLabel>
							<p>{lockMap ? 'The layer will stay on the map after tool is closed.' : 'The layer will automatically be removed.'}</p>
						</div>
					</div>
					<hr />
				</div>
			</div>
			<div>
				<h3>Select Species and / or Pathogen </h3>
				<p>To select a point, click the point you want on the map and press the <CalciteIcon icon="beaker"></CalciteIcon> action icon in the pop-up.</p>
				<p><em>Updating these options will reset the selected point.</em></p>
				<div>
					<CalciteLabel>
						Species: 
						<CalciteSelect label="Species" name="species" scale="m" onCalciteSelectChange={UpdateSpeciesOption}>
							<CalciteOption value={''} label="- All Species -" selected={!dataOptions.speciesKey}></CalciteOption>
							{
								keys.availableCurrentData
								.map( (bySpeciesData, key) =>{
									return (<CalciteOption key={key} value={bySpeciesData.speciesKey} 
										selected={dataOptions.speciesKey === bySpeciesData.speciesKey} label={
											`${keys.species[bySpeciesData.speciesKey].name} (${keys.species[bySpeciesData.speciesKey].sciName})`
										}></CalciteOption>);
								}) 
							}	
						</CalciteSelect>
					</CalciteLabel>
					<CalciteLabel>
						Pathogen: 
						<CalciteSelect label="Pathogen" name="pathogen" scale="m" onCalciteSelectChange={UpdatePathogenOption}>
							<CalciteOption value={''} label="- All Pathogens -" selected={!dataOptions.disease}></CalciteOption>
							{
								[...new Set(keys.availableCurrentData
								.flatMap( (bySpeciesData, key) =>{
									return bySpeciesData.pathogenKeys.map( (pathogenKey, subKey) => {
										return (<CalciteOption key={subKey+key} value={pathogenKey} 
											selected={dataOptions.pathogenKey === pathogenKey} label={
												`${keys.pathogens[pathogenKey].name}`
											}></CalciteOption>);
									})
								}) )] 
							}	
						</CalciteSelect>
					</CalciteLabel>
				</div>
				<h3>Select a timeframe </h3>
				<p><em>Updating the timeframe will <strong>NOT</strong> reset your selected point.</em></p>
				<div>
					<CalciteSelect label="Data Comparison Timeframe" name="dataTimeframe" scale="m" onCalciteSelectChange={UpdateDataTimeframe}>
						<CalciteOption value={'all'} label="- All Data Available -" selected={!dataOptions.dataTimeframe || dataOptions.dataTimeframe === 'all'}></CalciteOption>
						<CalciteOption value={'past-three'} label="Last 3 Years of Data" selected={dataOptions.dataTimeframe === 'past-three'}></CalciteOption>
						<CalciteOption value={'past-five'} label="Last 5 Years of Data" selected={dataOptions.dataTimeframe === 'past-five'}></CalciteOption>
					</CalciteSelect>
				</div>
				<hr />
			</div>
			<div ref={legendRef}></div>
			{ShowCurrentlySelectedPoint()}
		</div>
	);
}

const mapStateToProps = (state) => ({
    isMapLoading: state.isMapLoading,
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	loadLayerOnMap: (layer) => {dispatch(loadLayer(layer))},
	removeLayerFromMap: (layer) => {dispatch(removeLayer(layer))},
});

export default connect(mapStateToProps, mapDispatchToProps)(DataForGrowersPanel);
